module.exports = __webpack_public_path__ + "img/microsoft-dynamics.fb07f98f.png";